var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6L14.5 2M14.5 2H10.5M14.5 2L9.16667 7.33333M7.16667 3.33333H5.7C4.5799 3.33333 4.01984 3.33333 3.59202 3.55132C3.21569 3.74307 2.90973 4.04903 2.71799 4.42535C2.5 4.85318 2.5 5.41323 2.5 6.53333V10.8C2.5 11.9201 2.5 12.4802 2.71799 12.908C2.90973 13.2843 3.21569 13.5903 3.59202 13.782C4.01984 14 4.5799 14 5.7 14H9.96667C11.0868 14 11.6468 14 12.0746 13.782C12.451 13.5903 12.7569 13.2843 12.9487 12.908C13.1667 12.4802 13.1667 11.9201 13.1667 10.8V9.33333",
    stroke: "#363BC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.90145f034d4cc3ede5a4a993abd3d3d5.svg";
export { ForwardRef as ReactComponent };